import { apiClient } from '@/lib/apiClient';
import type { Timesheet, SalvarTimesheetRequest, CustoHora, SalvarCustoHoraRequest } from '../types';

const BASE = '/api/projetos/timesheet';

/** Filtros extras da fila de aprovação (datas "yyyy-MM-dd"). */
export interface FiltrosPendentes {
  funcionarioId?: number;
  inicio?: string;
  fim?: string;
}

export const timesheetService = {
  listarPorFuncionario: (funcionarioId: number, inicio: string, fim: string) =>
    apiClient.get<Timesheet[]>(BASE, { params: { funcionarioId, inicio, fim } }).then(r => r.data),
  pendentes: (projetoId = 0, filtros: FiltrosPendentes = {}) =>
    apiClient.get<Timesheet[]>(`${BASE}/pendentes`, {
      params: {
        projetoId,
        funcionarioId: filtros.funcionarioId || undefined,
        inicio: filtros.inicio || undefined,
        fim: filtros.fim || undefined,
      },
    }).then(r => r.data),
  porProjeto: (projetoId: number, status = -1) =>
    apiClient.get<Timesheet[]>(`${BASE}/por-projeto`, { params: { projetoId, status } }).then(r => r.data),

  criar: (req: SalvarTimesheetRequest) =>
    apiClient.post<Timesheet>(BASE, req).then(r => r.data),
  atualizar: (id: number, req: SalvarTimesheetRequest) =>
    apiClient.put<Timesheet>(`${BASE}/${id}`, req).then(r => r.data),
  excluir: (id: number) =>
    apiClient.delete(`${BASE}/${id}`).then(r => r.data),

  aprovar: (ids: number[]) =>
    apiClient.post(`${BASE}/aprovar`, { ids }).then(r => r.data),
  rejeitar: (ids: number[], motivo?: string) =>
    apiClient.post(`${BASE}/rejeitar`, { ids, motivo }).then(r => r.data),

  listarCustosHora: () =>
    apiClient.get<CustoHora[]>(`${BASE}/custo-hora`).then(r => r.data),
  salvarCustoHora: (req: SalvarCustoHoraRequest) =>
    apiClient.put<CustoHora>(`${BASE}/custo-hora`, req).then(r => r.data),
};
